import axios from "../config/axiosConfig";

// Create a new coin price
export const createCoinPrice = async (data) => {
  try {
    const response = await axios.post("/coinPrice", data);
    return response.data;
  } catch (error) {
    console.error("Error creating coin price:", error);
    throw error;
  }
};

// Get a coin price by its price ID
export const getCoinPriceById = async (priceId) => {
  try {
    const response = await axios.get(`/coinPrice/${priceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching coin price by ID:", error);
    throw error;
  }
};

// Get all prices for a specific coin by coin ID
export const getCoinPricesByCoinId = async (coinId, page = 1, limit = 10) => {
  try {
    const response = await axios.get(`/coinPrice/coin/${coinId}`, {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching coin prices by coin ID:", error);
    throw error;
  }
};
